import React, { useState, useCallback } from "react";

import {
  useNavigate,
  useRouteLoaderData,
  Link,
  useLoaderData,
} from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import EndCustomerPaidForm from "Components/Endcustomerpaid/EndCustomerPaidForm";
import Paper from "Components/UI/Paper";
import { updateEndCustomerPaid, deleteEndCustomerPaid } from "API/swesum";
import usePost2 from "Hooks/usePost";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function EndCustomerPaidCard() {
  const { endcustomerPaid, invoices } = useRouteLoaderData("paid");
  const files = useLoaderData();

  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { openSuccess, openError } = usePopupNotificationContext();

  const [formData, setFormData] = useState({
    Id: endcustomerPaid.Id ? endcustomerPaid.Id : "",
    InvoiceId: endcustomerPaid.InvoiceId ? endcustomerPaid.InvoiceId : "",
    FileId: endcustomerPaid.FileId ? endcustomerPaid.FileId : "",
    Amount: endcustomerPaid.Amount ? endcustomerPaid.Amount : 0,
    OCR: endcustomerPaid.OCR ? endcustomerPaid.OCR : "",
    EndCustomerName: endcustomerPaid.EndCustomerName
      ? endcustomerPaid.EndCustomerName
      : "",
    AccountRefId: endcustomerPaid.AccountRefId
      ? endcustomerPaid.AccountRefId
      : "",
    ParseStatus: endcustomerPaid.ParseStatus,
    ParseMessage: endcustomerPaid.ParseMessage,
    SystemStatus: endcustomerPaid.SystemStatus,
    CreateTime: endcustomerPaid.CreateTime,
    PaymentDate: endcustomerPaid.PaymentDate,
  });

  const updateInvoiceReq = usePost2({
    mtnFunc: (body) => {
      return updateEndCustomerPaid(endcustomerPaid.Id, body);
    },
    onSuccess: (data) => {
      openSuccess("Sparat", 3000);
    },
    onError: () => {
      openError("Ett fel har uppstått vid uppdatering av fakturan", 2000);
    },
  });
  const deleteInvoiceReq = usePost2({
    mtnFunc: () => deleteEndCustomerPaid(endcustomerPaid.Id),
    onError: () => {
      closeDialog();
      openError("Ett fel uppstod när fakturan sparades");
    },
    onSuccess: () => {
      closeDialog();
      navigate("/endcustomerpaid");
    },
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const updateInvoicee = () => {
    updateInvoiceReq.post(formData);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Paper>
        <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
          Slutkundsinbetalningskort - {endcustomerPaid.Id}
        </Typography>
        {formData && (
          <EndCustomerPaidForm
            formData={formData}
            endcustomerPaid={endcustomerPaid}
            handleInputChange={handleInputChange}
            invoices={invoices}
            files={files}
          />
        )}

        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={() => navigate(-1)} sx={{ ml: 1 }}>
            Stäng
          </Button>
          <Button onClick={updateInvoicee} variant="contained" sx={{ ml: 3 }}>
            Spara
          </Button>
        </Grid>
      </Paper>

      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>{"Ta bort faktura"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              "Fakturan kommer att tas bort från systemet. Åtgärden går inte att ångra."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Stäng</Button>
          <Button
            color="error"
            onClick={() => deleteInvoiceReq.post()}
            autoFocus
          >
            Ta bort
          </Button>
        </DialogActions>
      </Dialog>
      {updateInvoiceReq.loading && <Typography>{"Laddar"}</Typography>}
      {updateInvoiceReq.error && (
        <Typography color={"error"}>
          {JSON.stringify(updateInvoiceReq.error.response?.details)}
        </Typography>
      )}
    </>
  );
}
